// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/api-errors.ts
// Parameters       : none — this file is byte-identical across the fleet
// Destination      : packages/fleet/utils/src/api-errors.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo cartero-mail-app
//     node fleet/fleet.ts check --repo cartero-mail-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { I18n } from "@lingui/core";

/**
 * Extracts the error message from OpenAPI/API responses.
 * Internal utility for consistent HTTP error handling.
 */
function extractOpenAPIErrorMessage(error: unknown, i18n?: I18n): string {
  const fallback = i18n
    ? i18n._({ id: "error.unexpected", message: "An unexpected error occurred" })
    : "An unexpected error occurred";

  if (!error || typeof error !== "object") {
    return fallback;
  }
  if ("detail" in error && typeof error.detail === "string") {
    return error.detail;
  }
  if ("message" in error && typeof error.message === "string") {
    return error.message;
  }
  if ("error" in error && typeof error.error === "string") {
    return error.error;
  }
  return fallback;
}

/**
 * Creates an Error from OpenAPI/API responses.
 * Preserves the original stack trace when available.
 */
export function createOpenAPIError(error: unknown, i18n?: I18n): Error {
  const message = extractOpenAPIErrorMessage(error, i18n);

  // If the original error is an Error instance, preserve it
  if (error instanceof Error) {
    if (error.message !== message) {
      // Only update the message if it's different
      return new Error(message, { cause: error });
    }
    return error;
  }

  return new Error(message);
}

/**
 * Standardized response handling for openapi-fetch results.
 * Extracts data on success and throws a descriptive Error on failure.
 *
 * @param promise - The promise returned by an openapi-fetch call.
 * @param i18n - Optional i18n instance for localized error messages.
 * @returns The data part of the response if successful and non-null.
 * @throws Error with status and cause if the response contains an error or is empty.
 */
export async function handleApiResponse<T>(
  promise: Promise<{ data?: T | null; error?: unknown; response?: Response }>,
  i18n?: I18n,
): Promise<NonNullable<T>> {
  const { data, error, response } = await promise;

  if (error) {
    const err = createOpenAPIError(error, i18n);
    // Attach status for machine/guards if available
    if (response) {
      Object.assign(err, { status: response.status });
    }
    throw err;
  }

  if (data === undefined || data === null) {
    const err = new Error("API returned no data");
    if (response) {
      Object.assign(err, { status: response.status });
    }
    throw err;
  }

  return data as NonNullable<T>;
}
